import React from "react";
import { Redirect } from "react-router";
import { URLS } from "../../_config";
import { useAuthStatus } from "../hooks/auth/authHook";
import { useAppUserDetailsSelector } from "../hooks/selectors/userSelector";

// Pages include their own <Layout> wrapper, so this HOC only handles auth gating.
const requireAuth = (Component: React.ComponentType) => {
  function AuthHoc(props: any) {
    const isAuth = useAuthStatus();
    const user = useAppUserDetailsSelector();

    return isAuth && user ? (
      <Component {...props} />
    ) : (
      <Redirect to={URLS.AUTH.LOGIN} />
    );
  }

  return AuthHoc;
};
export default requireAuth;
